import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from 'react';

export const hasModuleAccess = (user, module) => {


  if (!user) return false;

  switch (module) {
    case "CRM":
      return user.crmAccess === true;

    case "HR":
      return [
        "SUPER_ADMIN",
        "ADMIN",
        "HR",
      ].includes(user.role);

    default:
      return false;
  }
};
